import { render, staticRenderFns } from "./MainConfigurations.vue?vue&type=template&id=f002c2ac"
import script from "./MainConfigurations.vue?vue&type=script&lang=js"
export * from "./MainConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports